<div class="login-box">
  <div class="login-logo">
    <img [src]="logo" width='30%' />
  </div>
  <div class="login-box-body">
    <p [hidden]="hasForgottenPassword" class="login-box-msg">{{'Sign in to your account' | titlecase}}</p>
    <p [hidden]="!hasForgottenPassword" class="login-box-msg">Reset Password</p>
    <form [hidden]="hasForgottenPassword">
      <div class="form-group has-feedback">
        <input type="text" [(ngModel)]="username" name="username" class="form-control" placeholder="Email">
        <span class="glyphicon glyphicon-envelope form-control-feedback"></span>
      </div>
      <div class="form-group has-feedback">
        <input type="password" [(ngModel)]="password" name="password" class="form-control" placeholder="Password">
        <span class="glyphicon glyphicon-lock form-control-feedback"></span>
      </div>
      <div class="row">
        <div class="col-xs-8">
          <div class="checkbox icheck">
            <label>
            </label>
          </div>
        </div>
        <div class="col-sm-4 col-xs-12">
          <button (click)="login()" class="btn btn-primary btn-block btn-flat">Sign In</button>
        </div>
        <div class="col-xs-12 col-sm-12">
          <a href="javascript:void(0)" (click)="toggleForgotPasswordClicked()">Forgot Password?</a>
        </div>
      </div>
    </form>
    <form [hidden]="!hasForgottenPassword">
      <div class="form-group">
        <div class="col-sm-12 col-xs-12">
          <input type="text" [(ngModel)]="email" name="email" class="form-control" placeholder="Email">
        </div>
        <div class="clearfix">&nbsp;</div>
        <!-- /.col -->
        <div class="col-sm-6 col-xs-12">
          <button (click)="resetPassword()" class="btn btn-primary btn-block btn-flat">Submit</button>
        </div>
        <div class="col-sm-6 col-xs-12">
          <button (click)="toggleForgotPasswordClicked()" class="btn btn-danger btn-block btn-flat">Cancel</button>
        </div>
        <br>
        <br>
      </div>
    </form>
  </div>
</div>
@if (modalService.showModal) {
<region-modal (regionSelected)="onRegionSelected($event)">
</region-modal>
}